export default __webpack_public_path__ + "static/media/caen11.249abb41.jpg";